import { Controller } from "@hotwired/stimulus"

// This controller is used to open a modal to save selected lead(s) to a new leads list.
export default class extends Controller {
  static get values() {
    return {
      filters: { type: Object, default: {} },
      selectedLeadIds: { type: Array, default: [] },
    }
  }

  show() {
    let url = new URL("/leads-lists/new", window.location.origin)

    if (this.selectedLeadIdsValue.length > 0) {
      this.selectedLeadIdsValue.forEach((leadId) => {
        url.searchParams.append("filters[lead_ids][]", leadId)
      })
    } else if (Object.entries(this.filtersValue).length > 0) {
      // If there are filters, we append them to the URL
      Object.entries(this.filtersValue).forEach(([key, value]) => {
        if (Array.isArray(value)) {
          value.forEach((arrayValue) => {
            url.searchParams.append("filters[" + key + "][]", arrayValue)
          })
        } else {
          url.searchParams.append("filters[" + key + "]", value)
        }
      })
    } else {
      url.searchParams.append("filters[leads_list_id]", "all")
    }

    Turbo.visit(url.toString(), { frame: "save_as_leads_list" })
  }

  // This action is used to update the selected leads value.
  // We trigger this using the check-all controller.
  updateSelection(event) {
    this.selectedLeadIdsValue = event.detail.dataSets
      .map((dataSet) => dataSet.leadId || dataSet.recordId)
      .filter(Boolean)
  }
}
